import { PDFViewer, PDFViewerProps } from '@progress/kendo-react-pdf-viewer';

export default function PdfViewer(props: PDFViewerProps) {
  return <PDFViewer {...props} />;
}
